// Add structure for ISO controls
export const isoControlsByDomain = {
  'GOVERNANCE': {
    'Organisational Controls': {
        controls: ['A.5.1', 'A.5.2', 'A.5.3', 'A.5.7', 'A.5.9', 'A.5.12', 'A.5.19', 'A.5.30', 'A.5.36'],
    },
    'People Controls': {
        controls: ['A.6.1', 'A.6.2', 'A.6.3', 'A.6.5'],
    }
    }, 
  'NETWORK': {
    'Physical Controls': {
        controls: ['A.7.11', 'A.7.12', 'A.7.13', 'A.7.14'],
    },
    'Technological Controls': {
        controls: ['A.8.6', 'A.8.12', 'A.8.15', 'A.8.16', 'A.8.20', 'A.8.21', 'A.8.22', 'A.8.23', 'A.8.24', 'A.8.31',]
    }
    },
  'INFRASTRUCTURE': {
    'Physical Controls': {
        controls: ['A.7.1', 'A.7.9', 'A.7.11', 'A.7.12', 'A.7.13', 'A.7.14'],
    },
    'Technological Controls': {
        controls: ['A.8.1', 'A.8.5', 'A.8.7', 'A.8.8', 'A.8.9', 'A.8.12', 'A.8.14', 'A.8.15', 'A.8.16', 'A.8.18', 'A.8.19', 'A.8.27']
    }
    },
  'APPLICATION': {
    'Physical Controls': {
        controls: ['A.7.10', 'A.7.13', 'A.7.14'],
    },
    'Technological Controls': {
        controls: ['A.8.1', 'A.8.7', 'A.8.8', 'A.8.9', 'A.8.10', 'A.8.11', 'A.8.12', 'A.8.13', 'A.8.15', 'A.8.16', 'A.8.24', 'A.8.25', 'A.8.26', 'A.8.28', 'A.8.29']
    }
    },
  'IDENTITY': {
    'Physical Controls': {
        controls: ['A.7.2', 'A.7.3'],
    },
    'Technological Controls': {
        controls: ['A.8.1', 'A.8.2', 'A.8.3', 'A.8.4', 'A.8.5', 'A.8.15']
    }
  }
};

export const isoControlDetails = {
  // ORGANISATIONAL CONTROLS //
'A.5.1': {
    name: 'Policies for information security',
    section: 'Organizational controls',
    description: 'Information security policy and topic-specific policies shall be defined, approved by management, published, communicated to and acknowledged by relevant personnel and relevant interested parties, and reviewed at planned intervals and if significant changes occur.'
    },
'A.5.2': {
    name: 'Information security roles and responsibilities',
    section: 'Organizational controls',
    description: 'Information security roles and responsibilities shall be defined and allocated according to the organization needs.'
    },
'A.5.3': {
    name: 'Segregation of duties',
    section: 'Organizational controls',
    description: 'Conflicting duties and conflicting areas of responsibility shall be segregated.'
    },
'A.5.7': {
    name: 'Threat intelligence',
    section: 'Organizational controls',
    description: 'Information relating to information security threats shall be collected and analysed to produce threat intelligence.'
    },
'A.5.9': {
    name: 'Inventory of information and other associated assets',
    section: 'Organizational controls',
    description: 'An inventory of information and other associated assets, including owners, shall be developed and maintained.'
    },
'A.5.12': {
    name: 'Classification of information',
    section: 'Organizational controls',
    description: 'Information shall be classified according to the information security needs of the organization based on confidentiality, integrity, availability and relevant interested party requirements.'
    },
'A.5.19': {
    name: 'Information security in supplier relationships',
    section: 'Organizational controls',
    description: 'Processes and procedures shall be defined and implemented to manage the information security risks associated with the use of supplier\'s products or services.'
    },
'A.5.30': {
    name: 'ICT readiness for business continuity',
    section: 'Organizational controls',
    description: 'ICT readiness shall be planned, implemented, maintained and tested based on business continuity objectives and ICT continuity requirements.'
    },
'A.5.36': {
    name: 'Compliance with policies, rules and standards for information security',
    section: 'Organizational controls',
    description: 'Compliance with the organization\'s information security policy, topic-specific policies, rules and standards shall be regularly reviewed.'
    },
  // PEOPLE CONTROLS //
'A.6.1': {
    name: 'Screening',
    section: 'People controls',
    description: 'Background verification checks on all candidates to become personnel shall be carried out prior to joining the organization and on an ongoing basis taking into consideration applicable laws, regulations and ethics and be proportional to the business requirements, the classification of the information to be accessed and the perceived risks.'
},
'A.6.2': {
    name: 'Terms and conditions of employment',
    section: 'People controls',
    description: 'The employment contractual agreements shall state the personnel\'s and the organization\'s responsibilities for information security.'
},
'A.6.3': {
    name: 'Information security awareness, education and training',
    section: 'People controls',
    description: 'Personnel of the organization and relevant interested parties shall receive appropriate information security awareness, education and training and regular updates of the organization\'s information security policy, topic-specific policies and procedures, as relevant for their job function.'
},
'A.6.5': {
    name: 'Responsibilities after termination or change of employment',
    section: 'People controls',
    description: 'Information security responsibilities and duties that remain valid after termination or change of employment shall be defined, enforced and communicated to relevant personnel and other interested parties.'
},
  // PHYSICAL CONTROLS //
'A.7.1': {
    name: 'Physical security perimeters',
    section: 'Physical controls',
    description: 'Security perimeters shall be defined and used to protect areas that contain information and other associated assets.'
},
'A.7.2': {
    name: 'Physical entry',
    section: 'Physical controls',
    description: 'Secure areas shall be protected by appropriate entry controls and access points.'
},
'A.7.3': {
    name: 'Securing offices, rooms and facilities',
    section: 'Physical controls',
    description: 'Physical security for offices, rooms and facilities shall be designed and implemented.'
},
'A.7.9': {
    name: 'Security of assets off-premises',
    section: 'Physical controls',
    description: 'Off-site assets shall be protected.'
},
'A.7.10': {
    name: 'Storage media',
    section: 'Physical controls',
    description: 'Storage media shall be managed through their life cycle of acquisition, use, transportation and disposal in accordance with the organization\'s classification scheme and handling requirements.'
},
'A.7.11': {
    name: 'Supporting utilities',
    section: 'Physical controls',
    description: 'Information processing facilities shall be protected from power failures and other disruptions caused by failures in supporting utilities.'
},
'A.7.12': {
    name: 'Cabling security',
    section: 'Physical controls',
    description: 'Cables carrying power, data or supporting information services shall be protected from interception, interference or damage.'
},
'A.7.13': {
    name: 'Equipment maintenance',
    section: 'Physical controls',
    description: 'Equipment shall be maintained correctly to ensure availability, integrity and confidentiality of information.'
},
'A.7.14': {
    name: 'Secure disposal or re-use of equipment',
    section: 'Physical controls',
    description: 'Items of equipment containing storage media shall be verified to ensure that any sensitive data and licensed software has been removed or securely overwritten prior to disposal or re-use.'
},
  // TECHNOLOGICAL CONTROLS //
'A.8.1': {
    name: 'User end point devices',
    section: 'Technological controls',
    description: 'Information stored on, processed by or accessible via user end point devices shall be protected.',
    threat_events: [
        'Data theft from endpoint devices',
        'Malware infection on endpoints',
        'Unauthorised device access',
        'Data leakage through endpoint compromise'
      ]
},
'A.8.2': {
    name: 'Privileged access rights',
    section: 'Technological controls',
    description: 'The allocation and use of privileged access rights shall be restricted and managed.'
},
'A.8.3': {
    name: 'Information access restriction',
    section: 'Technological controls',
    description: 'Access to information and other associated assets shall be restricted in accordance with the established topic-specific policy on access control.'
},
'A.8.4': {
    name: 'Access to source code',
    section: 'Technological controls',
    description: 'Read and write access to source code, development tools and software libraries shall be appropriately managed.'
},
'A.8.5': {
    name: 'Secure authentication',
    section: 'Technological controls',
    description: 'Secure authentication technologies and procedures shall be implemented based on information access restrictions and the topic-specific policy on access control.'
},
'A.8.6': {
    name: 'Capacity management',
    section: 'Technological controls',
    description: 'The use of resources shall be monitored and adjusted in line with current and expected capacity requirements.'
},
'A.8.7': {
    name: 'Protection against malware',
    section: 'Technological controls',
    description: 'Protection against malware shall be implemented and supported by appropriate user awareness.'
},
'A.8.8': {
    name: 'Management of technical vulnerabilities',
    section: 'Technological controls',
    description: 'Information about technical vulnerabilities of information systems in use shall be obtained, the organization\'s exposure to such vulnerabilities shall be evaluated and appropriate measures shall be taken.'
},
'A.8.9': {
    name: 'Configuration management',
    section: 'Technological controls',
    description: 'Configurations, including security configurations, of hardware, software, services and networks shall be established, documented, implemented, monitored and reviewed.'
},
'A.8.10': {
    name: 'Information deletion',
    section: 'Technological controls',
    description: 'Information stored in information systems, devices or in any other storage media shall be deleted when no longer required.'
},
'A.8.11': {
    name: 'Data masking',
    section: 'Technological controls',
    description: 'Data masking shall be used in accordance with the organization\'s topic-specific policy on access control and other related topic-specific policies, and business requirements, taking applicable legislation into consideration.'
},
'A.8.12': {
    name: 'Data leakage prevention',
    section: 'Technological controls',
    description: 'Data leakage prevention measures shall be applied to systems, networks and any other devices that process, store or transmit sensitive information.'
},
'A.8.13': {
    name: 'Information backup',
    section: 'Technological controls',
    description: 'Backup copies of information, software and systems shall be maintained and regularly tested in accordance with the agreed topic-specific policy on backup.'
},
'A.8.14': {
    name: 'Redundancy of information processing facilities',
    section: 'Technological controls',
    description: 'Information processing facilities shall be implemented with redundancy sufficient to meet availability requirements.'
},
'A.8.15': {
    name: 'Logging',
    section: 'Technological controls',
    description: 'Logs that record activities, exceptions, faults and other relevant events shall be produced, stored, protected and analysed.'
},
'A.8.16': {
    name: 'Monitoring activities',
    section: 'Technological controls',
    description: 'Networks, systems and applications shall be monitored for anomalous behaviour and appropriate actions taken to evaluate potential information security incidents.'
},
'A.8.18': {
    name: 'Use of privileged utility programs',
    section: 'Technological controls',
    description: 'The use of utility programs that can be capable of overriding system and application controls shall be restricted and tightly controlled.'
},
'A.8.19': {
    name: 'Installation of software on operational systems',
    section: 'Technological controls',
    description: 'Procedures and measures shall be implemented to securely manage software installation on operational systems.'
},
'A.8.20': {
    name: 'Networks security',
    section: 'Technological controls',
    description: 'Networks and network devices shall be secured, managed and controlled to protect information in systems and applications.'
},
'A.8.21': {
    name: 'Security of network services',
    section: 'Technological controls',
    description: 'Security mechanisms, service levels and service requirements of network services shall be identified, implemented and monitored.'
},
'A.8.22': {
    name: 'Segregation of networks',
    section: 'Technological controls',
    description: 'Groups of information services, users and information systems shall be segregated in the organization\'s networks.'
},
'A.8.23': {
    name: 'Web filtering',
    section: 'Technological controls',
    description: 'Access to external websites shall be managed to reduce exposure to malicious content.'
},
'A.8.24': {
    name: 'Use of cryptography',
    section: 'Technological controls',
    description: 'Rules for the effective use of cryptography, including cryptographic key management, shall be defined and implemented.'
},
'A.8.25': {
    name: 'Secure development life cycle',
    section: 'Technological controls',
    description: 'Rules for the secure development of software and systems shall be established and applied.'
},
'A.8.26': {
    name: 'Application security requirements',
    section: 'Technological controls',
    description: 'Information security requirements shall be identified, specified and approved when developing or acquiring applications.'
},
'A.8.27': {
    name: 'Secure system architecture and engineering principles',
    section: 'Technological controls',
    description: 'Principles for engineering secure systems shall be established, documented, maintained and applied to any information system development activities.'
},
'A.8.28': {
    name: 'Secure coding',
    section: 'Technological controls',
    description: 'Secure coding principles shall be applied to software development.'
},
'A.8.29': {
    name: 'Security testing in development and acceptance',
    section: 'Technological controls',
    description: 'Security testing processes shall be defined and implemented in the development life cycle.'
},
'A.8.31': {
    name: 'Separation of development, test and production environments',
    section: 'Technological controls',
    description: 'Development, testing and production environments shall be separated and secured.'
}
};